import Controller from "@ember/controller";
import { service } from "@ember/service";
import type SemeiaSessionService from "parog-web/services/session";

export default class ApplicationController extends Controller {
  @service declare session: SemeiaSessionService;
}
